import { useOutletContext } from "react-router-dom";

import ContractorsView from "../../../contractors/views/ContractorsView/ContractorsView";

export default function OrganizationSettingsContractors() {
	const { organization } = useOutletContext();

	return <ContractorsView publisher={organization} />;
}
